import { useTranslation } from "next-i18next";
import { FC } from "react";
import { Container } from "~/components/Container";
import Trans from "~/types/translationKeys";
import styles from "./Hero.module.scss";

interface Hero {
  title?: string;
}

const Hero: FC<Hero> = ({ title = Trans.resources_center }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.hero}>
      <Container className={styles.container}>
        <h1 className={styles.title}>{t(title)}</h1>
      </Container>
    </section>
  );
};

export default Hero;
